import React, { useEffect } from "react";
import "../styles/home.css";
import { Container, Row, Col, Button } from "reactstrap";
// import heroImg from "../assets/images/1f.jpg";
// import heroVideo from "../assets/images/car.jpeg";
import Subtitle from "./../shared/Subtitle";
import Img from "./../assets/images/therusticpaths.png";
import ServiceList from "../services/ServiceList";
import ServiceList1 from "../services/ServiceList1";
import FeaturedTourList from "../components/Featured-tours/FeaturedTourList";
import MasonryImagesGallery from "../components/Image-gallery/MasonryImagesGallery";
// import experienceImg from "../assets/images/experience.png";
// import rating from "../assets/images/rating.png";
import Newsletter from "../shared/Newsletter";
import AchievementsSection from "../shared/AchievementsSection";
import FeaturedTourList1 from "../components/Featured-tours/FeaturedTourList1";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import { Helmet } from "react-helmet";
// Import Swiper styles

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import Hero from "../components/Hero/Hero";
// import TransportationRankingCard from "../components/TripadvisorReview/TransportationRankingCard";
// import Heros from "../components/Hero/Heros";
// import SearchBar2 from "../shared/SearchBar2";
// import Searchbar3 from "../shared/Searchbar3";
// import SearchBar from "../shared/SearchBar";

const Home = () => {
  useEffect(() => {
    // Create a script element for the ElfSight widget
    const script = document.createElement("script");
    script.src = "https://static.elfsight.com/platform/platform.js";
    script.setAttribute("data-use-service-core", "");
    script.defer = true;

    // Append the script element to the body
    document.body.appendChild(script);

    // Clean up by removing the script when the component unmounts
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  useEffect(() => {
    AOS.init({
      duration: 800,
      once: false,
      easing: "ease-out",
    });

    // Clean up by destroying and reinitializing AOS when the component unmounts
    return () => {
      AOS.refreshHard();
    };
  }, []);

  return (
    <>
      <Helmet>
        <title>
          Jaipur Sightseeing | The Rustic Paths
        </title>
        <meta name="author" content="The Rustic Paths" />
        <meta
          name="description"
          content="Travel India with the Rustic Paths and experience the best of what the country has to offer. We offer a wide range of tour packages to suit your budget and interests, including the Golden Triangle Tour, South India Tour, Rajasthan Tour, Same Day Tour, Char Dham Tour and Short Tour. Our experienced drivers will take care of all the logistics, so you can relax and enjoy your journey."
        />
        <meta name="image" content={Img} />
        <meta
          name="keywords"
          content="The Rustic Paths, book a driver in India, tour packages India, Jaipur Sightseeing Day tour, Golden Triangle Tour, South India Tour, Rajasthan Tour, Same Day Tour, Char Dham Tour, Short Tour"
        />
        <meta name="robots" content="index, follow" />
        <meta
          property="og:title"
          content="Jaipur Sightseeing | The Rustic Paths"
        />
        <meta
          property="og:description"
          content="Travel India with a private driver and experience the best of what the country has to offer."
        />
        <meta property="og:image" content={Img} />
        <meta property="og:url" content="https://therusticpaths.com" />
        <meta property="og:type" content="website" />

        <link href="https://www.youtube.com/watch?v=8b2zj7fHQ5s" />
        <script type="application/ld+json">
        {`
        {
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "The Rustic Paths",
          "url": "https://therusticpaths.com",
          "logo": "${Img}",
          "sameAs": [
            "https://www.facebook.com/therusticpaths/",
            "https://www.youtube.com/channel/UCZkMu4NQxTp3DMekpKO6oCA",
            "https://instagram.com/therusticpaths/",
            "https://www.tripadvisor.com/Attraction_Review-g304555-d10807588-Reviews-The_Rustic_Paths-Jaipur_Jaipur_District_Rajasthan.html"
          ]
        }
        `}
      </script>

        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@type": "WebSite",
            "name": "The Rustic Paths",
            "url": "https://therusticpaths.com"
          }
          `}
        </script>
      </Helmet>
      {/*Hero Section Start*/}
      <section>
        <Container>
          <Row>
            <Col lg="12">
              <Hero />
            </Col>
          </Row>
        </Container>
      </section>
      {/*Hero Section End*/}
      {/*------------------About Us Start------------------- */}
      <section data-aos="fade-up">
        <Container>
          <Row>
            <Col lg="12">
              {/* <h5 className="services__subtitle">About us</h5> */}
              <Subtitle subtitle={"About Us"} />
            </Col>
            <p className="para">
            At The Rustic Paths,we curate customized tour itineraries and provide tour packages that offer sustainable and responsible tourism opportunities, showcasing the best of India’s heritage while empowering rural communities.
            </p>
            <Link to="/about-us">
              <Button style={{ float: "right" }} className="primary__btn">
                Know more...
              </Button>
            </Link>
          </Row>
        </Container>
      </section>

      {/*------------------About Us End------------------- */}

      {/*--------------------------- Our Achievements Section Start--------------------------*/}
      <section data-aos="fade-right">
        <Container>
          <Row>
            <Col lg="12">
              {/* <div style={{ backgroundColor: "#ffffff" }}>
                <h2 align="center" className="services__subtitle">
                  Few of our achievements
                </h2>
              </div> */}
              <Subtitle subtitle={"Few of our achievements"} />
            </Col>
            <Col lg="12">
              <AchievementsSection />
            </Col>
          </Row>
        </Container>
      </section>

      {/*--------------------------- Our Achievements Section End--------------------------*/}

      {/* --------------------------Testimonials sections starts*--------------------------*/}
      <section data-aos="fade-right">
        <Container>
          <Row>
            <Col lg="12">
              <Subtitle subtitle={"Fans Love"} />
              <h2 className="testimonial__title">What our fans say about us</h2>
            </Col>
            {/* <Col lg="8">
              <div className="elfsight-app-67d8eea9-b408-49ad-8765-9edf92c75e9a"></div>
            </Col>
            <Col lg="4">
            <div className="elfsight-app-155f2946-4fef-44ca-a7ac-209b4e155552"></div>
            </Col> */}
            <Col lg="12">
            <div className="elfsight-app-67d8eea9-b408-49ad-8765-9edf92c75e9a"></div>
            </Col>
          </Row>
        </Container>
      </section>
      {/*------------------------------------------ Testimonials sections ends----------------------------------------------*/}

      <section data-aos="fade-up">
        <Container>
          <Row>
            <Col lg="12">
              {/* <h5 className="services__subtitle">Why choose us</h5>
               */}<Subtitle subtitle={"Why Choose Us"} />
              {/* <h2 className="services__title">
                Book with us for affordable, comfortable, <br /> and premium
                tours with expert support.
              </h2> */}
            </Col>
            <ServiceList1 />
          </Row>
        </Container>
      </section>

      {/* <section>
        <Container>
          <Row>
            <Col lg={6}>
              <Searchbar3/>
              </Col>
          </Row>
        </Container>
      </section>  */}

      {/* Featured Tours Start*/}
      <section data-aos="fade-left">
        <Container>
          <Row>
            <Col lg="12" className="mb-5">
              <Subtitle subtitle={"Explore"} />
              <h2 className="featured__tour-title">Our Featured Tours</h2>
            </Col>
            <FeaturedTourList />
          </Row>
        </Container>
      </section>
      {/* Featured Tours end*/}

      <section data-aos="fade-right">
        <Container>
          <Row>
            <Col lg="3">
              {/* <h5 className="services__subtitle">What we serve</h5> */}
              <Subtitle subtitle={"What we serve"} />
              <h2 className="services__title">We Offer Our Best Services</h2>
            </Col>
            <ServiceList />
          </Row>
        </Container>
      </section>

      {/* Experience sections starts*/}
      {/* s */}
      {/* Experience sections end*/}

      {/* Featured Tours Start*/}
      <section data-aos="fade-up">
        <Container>
          <Row>
            <Col lg="12" className="mb-5">
              <Subtitle subtitle={"Look Into"} />
              <h2 className="featured__tour-title">Popular Destinations</h2>
            </Col>
            <FeaturedTourList1 />
          </Row>
        </Container>
      </section>
      {/* Featured Tours end*/}

      {/* Gallery Section start*/}
      <section data-aos="fade-down">
        <Container>
          <Row>
            <Col lg="12">
              <Subtitle subtitle={"Gallery"} />
              <h2 className="gallery__title">
                Visit our customers tour gallery
              </h2>
            </Col>
            <Col lg="12">
              <MasonryImagesGallery />
            </Col>
          </Row>
        </Container>
      </section>
      {/* Gallery sections end*/}
      <Newsletter />
    </>
  );
};

export default Home;
